import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import TopBar from './TopBar';
import './Layout.css';

const AdminLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="layout">
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}
      <div className={`sidebar-wrapper ${sidebarOpen ? 'sidebar-wrapper-open' : ''}`}>
        <AdminSidebar onNavClick={() => setSidebarOpen(false)} />
      </div>
      <div className="layout-main">
        <TopBar onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
        <div className="layout-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
